import { render, staticRenderFns } from "./AssignedMindbodyIndex.vue?vue&type=template&id=6d6c959a&scoped=true&"
import script from "./AssignedMindbodyIndex.vue?vue&type=script&lang=js&"
export * from "./AssignedMindbodyIndex.vue?vue&type=script&lang=js&"
import style0 from "./AssignedMindbodyIndex.vue?vue&type=style&index=0&id=6d6c959a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c959a",
  null
  
)

export default component.exports